import {
  Component,
  Input,
  HostBinding,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  OnInit,
  AfterContentChecked,
} from '@angular/core';

import { TranslateService } from '@app/_modules/translate/translate.service';
import { BreakpointService } from '@app/_services';

@Component({
    selector: 'more-block',
    templateUrl: './more.block.template.html',
    styleUrls: ['./more.block.styles.scss'],
    standalone: false
})

export class MoreBlockComponent implements AfterContentChecked, OnInit {
  @Input() content: any = false;
  @Input() id: string;
  @ViewChild('moreContent') moreContentElem: ElementRef;
  public cutoffs: Object = {
    lg: 88,
    sm: 110,
  };
  public active: boolean = false;
  public show: boolean = false;
  public links: any;
  public screenReaderContent: string = '';
  public hasInitialized = false;
  public translatedContent: any = false;
  @HostBinding('class') get hostClasses(): string {
    return `${this.content ? 'content__box' : 'empty'} ${this.show ? 'show' : 'hide'}`;
  }
  constructor (
    private breakpointService: BreakpointService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.translatedContent = this.translate.get(this.content);
  }
  ngAfterContentChecked(): void {
    if (this.moreContentElem &&
      this.moreContentElem.nativeElement.clientHeight !== 0 &&
      this.translatedContent &&
      !this.hasInitialized
    ) {
      const contentElem = this.moreContentElem.nativeElement;
      this.links = document.querySelectorAll(`#moreContent-${this.id} a, .content__inner a`);
      this.setInnerLinkStates(this.show);
      this.screenReaderContent = this.translatedContent ? this.translatedContent.replace(/<[^>]*>/g, '') : '';
      if ((this.breakpointService.isDesktop())
        && contentElem && contentElem.clientHeight >= this.cutoffs['lg']
        ) {
        this.active = true;
      } else if (contentElem && contentElem.clientHeight >= this.cutoffs['sm']) {
        this.active = true;
      } else {
        this.show = false;
      }
      this.hasInitialized = true;
      this.cdr.detectChanges();
    }
  }
  setInnerLinkStates(state) {
    for (const link of this.links) {
      if (!state) {
        setTimeout(
          () => link
            .setAttribute('style', `visibility: ${state ? 'visible' : 'hidden'}`),
          225,
        );
      } else {
        link.setAttribute('style', `visibility: ${state ? 'visible' : 'hidden'}`);
      }
    }
  }
  changeState() {
    const newState = !this.show;
    this.setInnerLinkStates(newState);
    this.show = newState;
    if (newState) {
      document.getElementById(`wrapper-${this.id}`).focus();
    }
  }
}
